import { getSettingValueWithoutAssignment } from "@faire/retailer-visitor-shared/settings/__internal__/getSetting";
import { SALESFORCE_FALLBACK_SALES_REP_CALENDAR_URL } from "@faire/web-api--source/indigofair/settings/SALESFORCE_FALLBACK_SALES_REP_CALENDAR_URL";
export var getSettingSalesforceFallbackSalesRepCalendarUrl = function() {
    return getSettingValueWithoutAssignment(SALESFORCE_FALLBACK_SALES_REP_CALENDAR_URL, "https://calendly.com/madeleine-maxwell_15_mins");
};
